module.exports = __webpack_public_path__ + "officialStatic/img/olt-detailList12.4cda35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/olt-detailList12.png
// module id = QUU8
// module chunks = 0